const MONTHS_SHORT_FR = [
    "Jan",
    "Fév",
    "Mar",
    "Avr",
    "Mai",
    "Juin",
    "Juil",
    "Août",
    "Sep",
    "Oct",
    "Nov",
    "Déc",
];

/** Libellé d'axe : "Mar" ou "Mar 25" si la série couvre plusieurs années */
const monthLabel = (row, multiYear) =>
    `${MONTHS_SHORT_FR[(row.month ?? 1) - 1]}${
        multiYear ? ` ${String(row.year).slice(-2)}` : ""
    }`;

/**
 * Transforme la réponse de GET /hr/pilotage/mouvements en modèle
 * consommé par MouvementsSection.
 */
export const mapMouvements = (api) => {
    const hires = api.hires_by_month ?? [];
    const departures = api.departures_by_month ?? [];
    const multiYear = new Set(hires.map((r) => r.year)).size > 1;

    return {
        entrees: api.hires ?? 0,
        sorties: api.departures ?? 0,
        tauxEntrees: api.hire_rate ?? 0,
        tauxSorties: api.exit_rate ?? 0,
        labels: hires.map((r) => monthLabel(r, multiYear)),
        seriesEntrees: hires.map((r) => r.count ?? 0),
        seriesSorties: departures.map((r) => r.count ?? 0),
        turnoverGlobal: api.turnover_rate ?? 0,
        turnoverVolontaire: api.voluntary_turnover_pct ?? 0,
        turnoverInvolontaire: api.involuntary_turnover_pct ?? 0,
        onboardingsEnCours: api.onboardings_in_progress ?? 0,
        offboardingsEnCours: api.offboardings_in_progress ?? 0,
        delaiOnboarding: api.average_onboarding_delay ?? 0,
        delaiOffboarding: api.average_offboarding_delay ?? 0,
    };
};
